import React from 'react';
import { FormGroup, ControlLabel, FormControl } from 'react-bootstrap';
import WSManager from "../../WSHelper/WSManager";
import { withdrawAmount } from "../../WSHelper/WSCallings";
import * as WSC from "../../WSHelper/WSConstants";
import * as AppLabels from "../../helper/AppLabels";
import { MyContext } from '../../InitialSetup/MyProvider';
import { Helmet } from "react-helmet";
import MetaData from "../../helper/MetaData";
import CustomHeader from '../../components/CustomHeader';
import { Utilities } from '../../Utilities/Utilities';
import ls from 'local-storage';
import { MomentDateComponent } from '../CustomComponent';
import EditStateAndCityModal from '../../Modals/EditStateAndCityModal';


export default class Withdraw extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            mAmount: '',
            mAmountError: '',
            mAmountValid: '',
            winningAmt: ls.get('userBalance'),
            profileDetail: WSManager.getProfile(),
            minWithdrawAmount: Utilities.getMasterData() ? parseFloat(Utilities.getMasterData().min_withdrawal || 0) : '',
            maxWithdrawAmount: Utilities.getMasterData() ? parseFloat(Utilities.getMasterData().max_withdrawal || 0) : '',
            withdrawPendingData: '',
            allow_withdraw: '',
            showStateTagModal: false,
            isLoading:false
        }

    }

    UNSAFE_componentWillMount() {
        if (!this.props.location.state || !this.props.location.state.isFromWallet) {
            this.props.history.replace({ pathname: '/my-wallet' });
        } else {
            this.setState({ withdrawPendingData: this.props.location.state.withdrawStatus, allow_withdraw: this.props.location.state.allow_withdraw })
        }
    }

    componentDidMount = () => {
        if(process.env.REACT_APP_STATE_TAGGING_ENABLE > 0 && (!WSManager.getProfile().master_state_id || !WSManager.getProfile().city)){
            this.setState({
                showStateTagModal: true
            })
        }
    }

    onAmountChange = (e) => {
        this.setState({ mAmount: e.target.value })
        this.validateField(e.target.id, e.target.value)
    }

    validateField = (fieldName, value) => {
        let { minWithdrawAmount, winningAmt, maxWithdrawAmount } = this.state;
        let winAmount = parseFloat(winningAmt.winning_amount || 0)
        var mAmountValid = value >= minWithdrawAmount && value <= winAmount;
        if (maxWithdrawAmount > 0) {
            mAmountValid = mAmountValid && value <= maxWithdrawAmount
        }
        let mAmountError = mAmountValid ? '' : ' ' + AppLabels.is_invalid;

        this.setState({
            mAmountError: mAmountError,
            mAmountValid: mAmountValid,
        }, this.validateForm(false));
    }

    validateForm = (submit) => {

        const { mAmountValid } = this.state;

        this.setState({
            formValid: mAmountValid
        }, () => {
            if (submit) {
                this.callWithrawBalanceApi();
            }
        });
    }

    validateOnSubmit = () => {

        let { mAmount, minWithdrawAmount, winningAmt, maxWithdrawAmount } = this.state;
        if (mAmount == '' || mAmount == 0) {
            Utilities.showToast(AppLabels.PLEASE_ENTER_AMOUNT, 2000);
        } else {
            let winAmount = parseFloat(winningAmt.winning_amount || 0)
            var mAmountValid = mAmount >= minWithdrawAmount && mAmount <= winAmount;
            if (maxWithdrawAmount > 0) {
                mAmountValid = mAmountValid && mAmount <= maxWithdrawAmount
            }
            let mAmountError = mAmountValid ? '' : ' ' + AppLabels.is_invalid;
            if(winAmount == 0 || winAmount < mAmount){
                Utilities.showToast(AppLabels.SUFFICIENT_WINNING, 3000);
            }else if (mAmount !== '' && !mAmountValid) {
                let msg = AppLabels.MIN_WITHDRAW_LIMIT + this.state.minWithdrawAmount + (this.state.maxWithdrawAmount ? (AppLabels.MAX_WITHDRAW_LIMIT + Utilities.getMasterData().currency_code + this.state.maxWithdrawAmount) : "")
                Utilities.showToast(msg, 3000);
            }

            this.setState({
                mAmountError: mAmountError,
                mAmountValid: mAmountValid,
            }, this.validateForm(mAmountValid));
        }
    }

    errorClass(error) {
        if (error) {
            return (error.length == 0 ? '' : 'has-error');
        }
    }

    callWithrawBalanceApi() {
        this.setState({
            isLoading: true
        })
        let param = {
            "amount": this.state.mAmount,
        }

        withdrawAmount(param).then((responseJson) => {
            setTimeout(() => {
                this.setState({
                    isLoading: false
                })
            }, 50);        
            // if (responseJson.status == 0) {
                Utilities.showToast(responseJson.message, 3000);
                this.props.history.replace({ pathname: '/my-wallet' })
            // }
        })
    }

    hideStateTagModal = () => {
        this.setState({
            showStateTagModal: false,
        });
    }

    render() {
        const {
            profileDetail, winningAmt, withdrawPendingData, allow_withdraw, showStateTagModal, isLoading
        } = this.state;

        const HeaderOption = {
            back: true,
            notification: false,
            title: AppLabels.WITHDRAW,
            fromAddFund: true,
            hideShadow: true
        }
        let banCodeMSg = AppLabels.BANK + ' ' + AppLabels.CODE;
        return (
            <MyContext.Consumer>
                {(context) => (
                    <div className="web-container web-container-fixed withdraw-page-wapper white-bg">
                        <Helmet titleTemplate={`${MetaData.template} | %s`}>
                            <title>{MetaData.addfunds.title}</title>
                            <meta name="description" content={MetaData.addfunds.description} />
                            <meta name="keywords" content={MetaData.addfunds.keywords}></meta>
                        </Helmet>
                        <CustomHeader {...this.props} HeaderOption={HeaderOption} />
                        <div className={"withdraw-header header-with-circle" + (allow_withdraw !== 0 ? '': ' pending-section')}>
                            {allow_withdraw !== 0 ?
                                <React.Fragment>
                                    <div className="total-winning-section">
                                        <div className="display-table-cell winning-text-section">
                                            <i className="icon-badge"></i>
                                            <h2>{AppLabels.TOTAL_WINNINGS}</h2>
                                            <p>{AppLabels.YOU_CAN_WITHDRAW_ONLY_FROM_WINNING}</p>
                                        </div>
                                        <div className="display-table-cell winning-amount text-right">
                                            {Utilities.getMasterData().currency_code} {winningAmt.winning_amount}
                                        </div>
                                    </div>
                                </React.Fragment>
                                :
                                <React.Fragment>
                                    <div className="total-winning-section pending-section">
                                        <div className="display-table-cell winning-text-section pl-0">
                                            <h2 className="text-capitalize">{AppLabels.PENDING_AMOUNT}</h2>
                                            <p><MomentDateComponent data={{ date: withdrawPendingData.date_added, format: "MMM DD - hh:mm a " }} /></p>
                                        </div>
                                        <div className="display-table-cell winning-amount text-right">
                                            {Utilities.getMasterData().currency_code} {withdrawPendingData.winning_amount}
                                        </div>
                                    </div>
                                </React.Fragment>
                            }
                            {allow_withdraw !== 0 ?
                                <div>
                                    <FormGroup
                                        className={'input-label-center input-transparent font-14 ' + (`${this.errorClass(this.state.mAmountError)}`)}
                                    >
                                        <ControlLabel>{AppLabels.ADD_AMOUNT}</ControlLabel>
                                        <FormControl
                                            id='amount'
                                            name='amount'
                                            placeholder={AppLabels.AMOUNT}
                                            type='number'
                                            onChange={this.onAmountChange}
                                        />
                                    </FormGroup>
                                </div>
                                :
                                <div className="withdrawal-status">
                                    {AppLabels.YOUR_WITHDRAWAL_REQUEST_IS_PENDING}
                                </div>
                            }
                        </div>
                        <div className="withdraw-body">
                            {allow_withdraw !== 0 &&
                                <div className="min-withdraw-text">{AppLabels.MIN_WITHDRAW_LIMIT}{this.state.minWithdrawAmount}{this.state.maxWithdrawAmount ?  (AppLabels.MAX_WITHDRAW_LIMIT + Utilities.getMasterData().currency_code + this.state.maxWithdrawAmount) : ""}</div>
                            }
                            {profileDetail.user_bank_detail.ac_number ? <div className="withdraw-acc-detail">
                                <div className="heading">{AppLabels.YOUR_WITHDRAWAL_AMOUNT_WILL_BE_CREDITED_TO_THIS_ACCOUNT}</div>
                                <div className="detail-for">{AppLabels.FULL_NAME_AS_BANK}</div>
                                <div className="detail-value">{(profileDetail.user_bank_detail.first_name || '') + ' ' + (profileDetail.user_bank_detail.last_name || '')} </div>
                                <div className="detail-for">{AppLabels.BANK_NAME}</div>
                                <div className="detail-value">{profileDetail.user_bank_detail.bank_name}</div>
                                <div className="detail-for">{AppLabels.ACCOUNT_NUMBER}</div>
                                <div className="detail-value">{profileDetail.user_bank_detail.ac_number}</div>
                                {/* {
                                    Utilities.getMasterData().int_version != 1 && <> */}
                                        <div className="detail-for">{Utilities.getMasterData().int_version != 1 ? AppLabels.IFSC_CODE : banCodeMSg}</div>
                                        <div className="detail-value">{profileDetail.user_bank_detail.ifsc_code}</div>
                                    {/* </>
                                } */}
                            </div> : <div className='pb-5' /> }
                            {allow_withdraw !== 0 ?
                                <div className="text-center">
                                    <a href className={"button button-primary-rounded button-block" + (isLoading ? ' disabled' : '')} onClick={() => this.validateOnSubmit()}>{AppLabels.WITHDRAW}</a>
                                </div>
                                :
                                <div className="text-center withdraw-help-text">{AppLabels.RAISE_ANOTHER_WITHDRAWAL_REQUEST}</div>
                            }
                        </div>
                        {
                            showStateTagModal &&
                            <EditStateAndCityModal
                                {...this.props}
                                mShow={showStateTagModal}
                                mHide={this.hideStateTagModal}
                            />
                        }
                    </div>
                )}
            </MyContext.Consumer>
        )
    }
}